import { ReactElement } from "react";
import { cn } from "@/lib/utils";

interface ApplicationLogoProps {
    className?: string;
    iconOnly?: boolean;
}

export function ApplicationLogo({ className, iconOnly = false }: ApplicationLogoProps): ReactElement {
    if (iconOnly) {
        return (
            <img
                src="/images/carzelle-icon.png"
                alt="Novazelle"
                className={cn("h-8 w-8 rounded", className)}
            />
        );
    }

    return (
        <img
            src="/images/carzelle-logo.png"
            alt="Novazelle"
            className={cn("h-8 w-auto", className)}
        />
    );
}
